/**
 * Field-clash key composition (spec §7.13, §8.6).
 *
 * The engine compares only opaque key strings; the app composes them here so
 * there is ONE implementation shared by web and api. An empty/blank field name
 * yields `undefined`, which tells the engine to skip field-clash checks for
 * that game. The key format is `${venueId ?? "adhoc"}|${trim(lowercase(field))}`.
 */
export function composeFieldKey(venueId, field) {
    if (field === undefined || field === null)
        return undefined;
    const normalized = field.trim().toLowerCase();
    if (normalized === "")
        return undefined;
    return `${venueId ?? "adhoc"}|${normalized}`;
}
//# sourceMappingURL=fieldKey.js.map